import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CustomXmlListComponent } from './custom-xml-list/custom-xml-list.component';
import { RangesListComponent } from './ranges-list/ranges-list.component';
import { MainToolsComponent } from './main-tools/main-tools.component';
import { WorksheetsListComponent } from './worksheets-list/worksheets-list.component';
import { WorkbookFunctionsComponent } from './workbook-functions/workbook-functions.component';
import { AiChatComponent } from './ai-chat/ai-chat.component';


export const routes: Routes = [
    { path: '', redirectTo: 'tools/worksheets', pathMatch: 'full' },
    { path: 'index.html', redirectTo: '/tools/worksheets', pathMatch: 'full' },
    { path: 'home', redirectTo: '/tools/home', pathMatch: 'full' },
    { path: 'tools', component: MainToolsComponent, children: [
            { path: 'home', component: HomeComponent },
            { path: 'worksheets', component: WorksheetsListComponent },
            { path: 'customxml', component: CustomXmlListComponent },
            { path: 'ranges', component: RangesListComponent },
            { path: 'workbook', component: WorkbookFunctionsComponent },
            { path: 'chat', component: AiChatComponent },
        ]
    }
];
